interface Props {
  status: string
}

const VALID_STATUSES = new Set(['charging', 'discharging', 'idle', 'unknown'])

export function StatusBadge({ status }: Props) {
  const normalized = status.toLowerCase()
  const cssClass = VALID_STATUSES.has(normalized) ? normalized : 'unknown'
  const label = status.charAt(0).toUpperCase() + status.slice(1)

  return <span className={`status-badge status-${cssClass}`}>{label}</span>
}
